import React from "react";
import { appColors, appRadius, appType } from "../../utils/appTheme";

/**
 * Botón al estilo app. Peso 400 siempre.
 * variant: "primary" (azul sólido) | "outline" (transparente + borde) | "ghost"
 * block: full-width. El :active scale lo aporta el CSS global de .residentApp.
 */
const AppButton = ({
  children,
  variant = "primary",
  block = false,
  icon,
  onClick,
  disabled = false,
  type = "button",
  style,
  ...rest
}) => {
  const base = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "13px 16px",
    borderRadius: appRadius.button,
    fontFamily: appType.fontFamily,
    fontSize: 14.5,
    fontWeight: 400,
    lineHeight: 1,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    transition: "background .15s ease, border-color .15s ease",
    width: block ? "100%" : undefined,
    border: "1px solid transparent",
  };

  const variants = {
    primary: {
      background: appColors.blue,
      color: appColors.onBlue,
    },
    outline: {
      background: "transparent",
      color: appColors.ink,
      borderColor: appColors.line,
    },
    ghost: {
      background: "transparent",
      color: appColors.blue,
    },
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{ ...base, ...variants[variant], ...style }}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
};

export default AppButton;
